var _effectorFileName = "/src/shared/config/env.mjs";
import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';
export const env = createEnv({
  server: {},
  client: {
    NEXT_PUBLIC_APP_NAME: z.string().optional(),
    NEXT_PUBLIC_APP_VERSION: z.string().optional(),
    NEXT_PUBLIC_BUILD_TIME: z.string().optional(),
    NEXT_PUBLIC_APP_URL: z.string().min(1),
    NEXT_PUBLIC_RU_SITE_URL: z.string().min(1),
    NEXT_PUBLIC_API_ENDPOINT: z.string().min(1),
    NEXT_PUBLIC_TG_BOT_ID: z.string().min(1),
    NEXT_PUBLIC_YANDEX_METRICS_ID: z.string().min(1),
    NEXT_PUBLIC_GOOGLE_ANALYTICS_ID: z.string().min(1),
    NEXT_PUBLIC_GOOGLE_TAG_ID: z.string().min(1),
    NEXT_PUBLIC_FB_PIXEL_ID: z.string().min(1),
    NEXT_PUBLIC_B2B_URL: z.string().min(1),
    NEXT_PUBLIC_GMAIL: z.string().min(1),
    NEXT_PUBLIC_LINKEDIN_URL: z.string().min(1),
    NEXT_PUBLIC_TG_SUPPORT_URL: z.string().min(1)
  },
  shared: {
    NODE_ENV: z.enum(['development', 'production', 'test']).default('development')
  },
  // If you're using Next.js < 13.4.4, you'll need to specify the runtimeEnv manually
  // runtimeEnv: {
  //   DATABASE_URL: process.env.DATABASE_URL,
  //   OPEN_AI_API_KEY: process.env.OPEN_AI_API_KEY,
  //   NEXT_PUBLIC_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_PUBLISHABLE_KEY,
  // },
  // For Next.js >= 13.4.4, you only need to destructure client variables:
  experimental__runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_APP_NAME: process.env.NEXT_PUBLIC_APP_NAME,
    NEXT_PUBLIC_APP_VERSION: process.env.NEXT_PUBLIC_APP_VERSION,
    NEXT_PUBLIC_BUILD_TIME: process.env.NEXT_PUBLIC_BUILD_TIME,
    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
    NEXT_PUBLIC_RU_SITE_URL: process.env.NEXT_PUBLIC_RU_SITE_URL,
    NEXT_PUBLIC_API_ENDPOINT: process.env.NEXT_PUBLIC_API_ENDPOINT,
    NEXT_PUBLIC_B2B_URL: process.env.NEXT_PUBLIC_B2B_URL,
    NEXT_PUBLIC_TG_BOT_ID: process.env.NEXT_PUBLIC_TG_BOT_ID,
    NEXT_PUBLIC_YANDEX_METRICS_ID: process.env.NEXT_PUBLIC_YANDEX_METRICS_ID,
    NEXT_PUBLIC_GOOGLE_ANALYTICS_ID: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID,
    NEXT_PUBLIC_GOOGLE_TAG_ID: process.env.NEXT_PUBLIC_GOOGLE_TAG_ID,
    NEXT_PUBLIC_FB_PIXEL_ID: process.env.NEXT_PUBLIC_FB_PIXEL_ID,
    NEXT_PUBLIC_GMAIL: process.env.NEXT_PUBLIC_GMAIL,
    NEXT_PUBLIC_LINKEDIN_URL: process.env.NEXT_PUBLIC_LINKEDIN_URL,
    NEXT_PUBLIC_TG_SUPPORT_URL: process.env.NEXT_PUBLIC_TG_SUPPORT_URL
  },
  emptyStringAsUndefined: true,
  skipValidation: process.env.NODE_ENV === 'test'
});